// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"linkButton_linkButton__37GAY"};